import { useCallback } from 'react';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Ergonomic accessor over the Zustand auth-store. Returns the current user,
 * a stable `logout` fn, and a `hasPermission(code)` guard used by nav items
 * and action buttons.
 */
export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const logoutImpl = useAuthStore((s) => s.logout);
  const hasPermissionImpl = useAuthStore((s) => s.hasPermission);
  const canWriteImpl = useAuthStore((s) => s.canWrite);

  const logout = useCallback(async () => {
    await logoutImpl();
  }, [logoutImpl]);

  const hasPermission = useCallback(
    (code: string) => hasPermissionImpl(code),
    [hasPermissionImpl],
  );

  const canWrite = useCallback(
    (resource: string) => canWriteImpl(resource),
    [canWriteImpl],
  );

  return { user, isAuthenticated, logout, hasPermission, canWrite };
}
